import { ROUTES } from '@/constants/routes'

export const NAV_LINKS = [
  { label: 'Калькулятор', to: ROUTES.CALCULATOR },
  { label: 'Каталог', to: ROUTES.CATALOG },
  { label: 'Фин.услуги', to: ROUTES.FIN_SERVICES },
  { label: 'О компании', to: ROUTES.ABOUT },
  { label: 'Блог', to: ROUTES.BLOG },
  { label: 'Контакты', to: ROUTES.CONTACTS },
] as const

export const HEADER_PHONE = '8 (000) 000-00-00'
